import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import Tab from './tab';

function NavView({dashboardActionCount}) {
  const organisation = useSelector(state => state.organisation);
  const isBackOffice = authenticationService.roles().isBackOffice();
  const isOrganisationDeactivated = !organisation.enabled;

  return (
    <div className="nav-container">
      <nav>
        <Tab
          label="menu.dashboard"
          link="/dashboard"
          disabled={isOrganisationDeactivated}
          dashboardActionCount={dashboardActionCount}
        />
        <Tab
          label="menu.documents"
          link="/documents"
          disabled={isOrganisationDeactivated}
        />
        <Tab
          label="menu.clients"
          link="/clients"
          disabled={isOrganisationDeactivated}
        />
        <Tab
          label="menu.projects"
          link="/projects"
          disabled={isOrganisationDeactivated}
        />
        <Tab
          label="menu.subcontractors"
          link="/subcontractors"
          disabled={isOrganisationDeactivated}
        />
        <Tab
          label="menu.settings"
          link="/organisation"
          disabled={isOrganisationDeactivated && !isBackOffice}
        />
      </nav>
    </div>
  );
}

NavView.propTypes = {
  dashboardActionCount: PropTypes.number.isRequired
};

export default NavView;
